<template>
  <div class="ss__custom__header__user">
    <SsButton2
      type="text"
      v-if="!isLogin || !userInfo || !userInfo.id"
      @click="onBtnLoginClick"
      class="ss__custom__header__btn__login">
      <i class="ssCommunityIcon__account"/>
    </SsButton2>

    <div v-else
      tabindex="-1"
      @mouseenter="open"
      @mouseleave="close">
      <SsButton2
        type="text"
        class="ss__custom__header__user__avatar"
        ref="showMenuBtn">
        <SsPortrait
          class="comp__SsPortrait"
          :data="userInfo"
          :size="0"
          :proportion="0"
        />
      </SsButton2>

      <transition name="ss__custom__header__fade">
        <SsCustomHeaderUserMenu
          class="ss__custom__header__user__menu"
          v-show="visible"
          :user="userInfo"
          :style="{
            left: `${offsetLeft}px`,
            top: `${offsetTop}px`
          }"
          ref="menu"
          @logout="$emit('logout')"
          :reminders="reminders"
        />
      </transition>

      <SafeArea
        v-if="visible"
        :svgWidth="298"
        :left="offsetLeft"
        :mouseX="mouseX"
        :mouseY="mouseY"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import SafeArea from '../SafeArea/index.vue'
import SsCustomHeaderUserMenu from '../SsCustomHeader/_components/SsCustomHeaderUserMenu/index.vue'
import SsButton2 from '../SsButton2'
import SsPortrait from '../SsPortrait'

export default {
  name: 'SsCustomHeaderUser',

  components: {
    SafeArea,
    SsCustomHeaderUserMenu,
    SsButton2,
    SsPortrait
  },

  props: {
    visible: Boolean,
    isLogin: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: null
    },
    reminders: {
      type: Object
    }
  },

  data () {
    return {
      theme: 0,
      offsetLeft: 0,
      offsetTop: 0,
      mouseX: 0,
      mouseY: 0
    }
  },

  methods: {
    open () {
      this.$emit('update:visible', true)
      this.$nextTick(() => {
        const showMenuBtn = this.$refs.showMenuBtn.$el
        const menu = this.$refs.menu.$el
        const { left: leftRef, top: topRef, width: widthRef, height: heightRef } = showMenuBtn.getBoundingClientRect()
        const { width: widthTarget } = menu.getBoundingClientRect()
        this.offsetLeft = leftRef - widthTarget + widthRef
        this.offsetTop = topRef + heightRef
      })
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'user' }))
    },
    close () {
      this.$emit('update:visible', false)
    },
    onBtnLoginClick () {
      this.$emit('login')
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'login' }))
    },
    updateMousePosition: debounce(function (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY - 4
    }, 30)
  },

  mounted () {
    this.theme = window.localStorage.getItem('darkMode') ? parseInt(window.localStorage.getItem('darkMode')) : 0
    window.addEventListener('mousemove', this.updateMousePosition)
  },

  destoryed () {
    window.removeEventListener('mousemove', this.updateMousePosition)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__custom__header__user {
  .ss__custom__header__btn__login {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnLogin, 32px);
    height: var(--h-ssCustonHeaderBtnLogin, 32px);
    i {
      font-size: var(--size-ssCustonHeaderBtnLogin, 20px);
      color: var(--color-ssCustonHeaderBtnLogin, var(--B8-t));
    }
  }

  .ss__custom__header__user__avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnLogin, 32px);
    height: var(--h-ssCustonHeaderBtnLogin, 32px);
    .comp__SsPortrait {
      --size: 24px;
      --proportion: calc(32 / 24);
    }
  }

  .ss__custom__header__user__menu {
    position: fixed;
    padding-top: 8px;
    z-index: 3;
  }
}

@media (min-width $screen-lg) {
  .ss__custom__header__user {
    .ss__custom__header__user__menu {
      top: 60px;
    }
  }
}
</style>
